import { TargetPlatform } from "../../../shared/types/TargetPlatform";

export const getTargetPlatformText = (targetPlatform: TargetPlatform): string => {
    switch (targetPlatform) {
        case TargetPlatform.Binance:
            return 'B';
        case TargetPlatform.Deribit:
            return 'D';
        case TargetPlatform.SamsungWallet:
            return 'S';
        case TargetPlatform.TrustWallet:
            return 'T';
        case TargetPlatform.RevolutX:
            return 'R';
        case TargetPlatform.None:
        default:
            return '';
    }
};

export const getTargetPlatformName = (targetPlatform: TargetPlatform): string => {
    switch (targetPlatform) {
        case TargetPlatform.Binance:
            return 'Binance';
        case TargetPlatform.Deribit:
            return 'Deribit';
        case TargetPlatform.SamsungWallet:
            return 'Samsung Wallet';
        case TargetPlatform.TrustWallet:
            return 'Trust Wallet';
        case TargetPlatform.RevolutX:
            return 'RevolutX';
        case TargetPlatform.None:
        default:
            return 'None';
    }
};
